import styles from './WelcomePage.module.css';

import { Header } from '../../components/Header/Header';
import { ServiceBtn } from '../../UI/ServiceBtn/ServiceBtn.jsx';
import { FooterBtn } from '../../UI/FooterBtn/FooterBtn.jsx';

//import itemImg from '../../assets/slider_bg-img.png'
import psIcon from '../../assets/ps-icon.svg'
import xboxIcon from '../../assets/xbox-icon.svg'
import servicesIcon from '../../assets/services-icon.svg'
import steamIcon from '../../assets/steam-icon.svg'
import nintendoIcon from '../../assets/nintendo-icon.svg'
import valorantIcon from '../../assets/valorant-icon.svg'
import supportIcon from '../../assets/support-icon.svg'

export const WelcomePage = () => {
	
	return (
		<div className={styles.welcomeMain + ' main'}>
			<Header />
			<h2>Выберите раздел</h2>
			<div className={styles.bottomSection}>
				<div className={styles.gorSection}>
					<ServiceBtn
						title={'PlayStation'}
						underTitle={'Личный'}
						style={{ maxHeight: 85, background: '#006FE8' }}
						img={psIcon}
						url={'/home'}
						state={{ schema: '' }}
					/>
					<ServiceBtn
						title={'PlayStation'}
						underTitle={'Общий'}
						description={'Скидки до 80%🔥'}
						img={psIcon}
						style={{ maxHeight: 85, background: '#006FE8' }}
						url={'/PS_sharing/home'}
						state={{ schema: 'PS_sharing' }}
					/>
				</div>
				
				<ServiceBtn
					title={'Пополнение кошелька'}
					img={psIcon}
					style={{ background: '#8000B2' }}
					url={'/PS_keys/home'}
					state={{ schema: 'PS_keys' }}
				/>
				<ServiceBtn
					title={'Steam ⚡️'}
					description={'Комиссия 6%🔥'}
					img={steamIcon}
					url={'/steam/adding'}
					style={{ maxHeight: 75, background: 'linear-gradient(to right, #11274B, #133266, #1385B6)' }}
					state={{ schema: 'steam' }}
				/>
			</div>
			<div className={styles.bottomSection}>
				<div className={styles.gorSection}>
					<ServiceBtn
						title={'GamePass'}
						img={xboxIcon}
						url={'/xbox'}
						style={{ background: '#0F7C0F' }}
						state={{ schema: 'xbox' }}
					/>
					<ServiceBtn
						title={'Valorant VP'}
						img={valorantIcon}
						style={{ background: '#D81D1D', padding: "25px 5px" }}
						url={'/valorant_keys/home'}
						state={{ schema: 'valorant_keys' }}
					/>
				</div>
				<div className={styles.gorSection}>
					<ServiceBtn
						title={'Сервисы'}
						img={servicesIcon}
						style={{ background: '#592526' }}
						url={'/services/home'}
						state={{ schema: 'services' }}
					/>
					<ServiceBtn
						title={'Nintendo'}
						img={nintendoIcon}
						style={{ background: '#D63D6A' }}
						url={'/Nind_keys/home'}
						state={{ schema: 'Nind_keys' }}
					/>
				</div>
			</div>
			<footer className={styles.footer}>
				<FooterBtn 
					width={'100%'}
					img={supportIcon}
					title={'Support'}
					url={'https://t.me/eazysupp'}
					description={'Не нашли нужный товар? Остались вопросы? Проблема с заказом? Пишите сюда!'}
				/>
			</footer>
		</div>
	);
};
